import { HttpHeaders,HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';

import { environment } from '../../../environments/environment';
import { IUserDetails } from '../../admin/models/user.model';

@Injectable({
  providedIn: 'root'
})
export class UserApprovalService {
    constructor(private http: HttpClient,
        private apiService: ApiService) { }
        public getAllUserApprovalList(userApprovalSearchParam:IGlobalSearchParam):Observable<any> {
            return this.apiService.post(`UserProfiles/SearchUserApproval`,userApprovalSearchParam)
        }
        public approveUser(id:number,userDetails:IUserDetails):Observable<any>{
          return this.apiService.put(`UserProfiles/${id}`,userDetails);
        }
}